import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import Icon from "../../../../../icon";

import Rhythms from "../svg";
import { rhytCardTypes } from "../../../../../../common/parameters";
import { getWidth } from "../utils";

import { Rhyt, Bar, RemoveBox, OrderBtn, Selector, LineBreak, PlayBarButton } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";
import { convertToNewColors } from "../../../../../utils/convertToNewColors";

const Box = ({
    index,
    active,
    box,
    removeBox,
    boxes,
    setActive,
    changeOrder,
    removeRhyt,
    edit,
    rating,
    color,
    onLinebreakClick,
    isLineBreak,
    width,
    onPlayBar,
    isChristmas,
}: IProps) => {
    let classnames = cn(
        !edit && "DragBox",
        edit && "Edit",
        rating && (rating === "Correct" ? "Correct" : "Incorrect"),
        index === active ? "Active" : "Passive",
        isChristmas && "Christmas"
    );

    const stopPropagation = useCallback(e => {
        e.stopPropagation();
    }, []);

    if (!box || (box.length === 0 && index !== 0)) {
        return (
            <Bar
                key={index}
                className={classnames}
                onClick={() => {
                    removeBox!(index);
                }}
            >
                <RemoveBox>
                    <FormattedMessage {...messages.removeCard} />
                </RemoveBox>
            </Bar>
        );
    }
    let changeWidth = 17;
    let orderWidth = 0;
    let orderLeft = 0;
    if (index > 0) {
        orderWidth += changeWidth;
        orderLeft += changeWidth;
    }
    if (edit && index < boxes!.length - 1 - (boxes![boxes!.length - 1].length === 0 ? 1 : 0)) {
        orderWidth += changeWidth;
    }

    return (
        <Bar
            key={index}
            className={classnames}
            onClick={() => {
                if (edit) setActive!(index);
            }}
            style={{
                ...(!isChristmas && { backgroundColor: convertToNewColors(color) }),
                ...(width && { width: width - 20 }),
            }}
        >
            {edit && index > 0 && (
                <OrderBtn
                    onClick={e => {
                        e.stopPropagation();
                        changeOrder!(index, -1);
                    }}
                >
                    {"<"}
                </OrderBtn>
            )}
            {box.map((rhyt, rhytIndex) => {
                const BoxRhythm = Rhythms["rhyt_" + rhyt.replace(/-/g, "_")];
                return (
                    <Rhyt
                        key={rhytIndex}
                        className={cn(edit && "Selectable")}
                        style={{
                            width: (rhytCardTypes[rhyt].width || getWidth(rhytCardTypes[rhyt].time)) * 65,
                        }}
                        svgWidth={(rhytCardTypes[rhyt].scale || 1) * 100}
                        onClick={() => {
                            if (edit && index === active) {
                                removeRhyt!(index, rhytIndex);
                            }
                        }}
                    >
                        <BoxRhythm />
                    </Rhyt>
                );
            })}
            {edit && (index === active || isLineBreak) && (
                <LineBreak onClick={() => onLinebreakClick!(index)} isActive={isLineBreak!}>
                    <Icon i="system-break" />
                </LineBreak>
            )}
            {edit && index < boxes!.length - 1 - (boxes![boxes!.length - 1].length === 0 ? 1 : 0) && (
                <OrderBtn
                    onClick={e => {
                        e.stopPropagation();
                        changeOrder!(index, 1);
                    }}
                >
                    {">"}
                </OrderBtn>
            )}
            {edit && index !== active && (
                <Selector
                    style={{
                        left: orderLeft,
                        width: `calc(100% - ${orderWidth}px)`,
                    }}
                ></Selector>
            )}
            {!edit && (
                <PlayBarButton
                    onMouseDown={stopPropagation}
                    onTouchStart={stopPropagation}
                    onClick={e => {
                        onPlayBar!(index);
                    }}
                >
                    <Icon i="play" />
                </PlayBarButton>
            )}
        </Bar>
    );
};

export default Box;
